"use strict";

const style = require("!!css-loader!./style/index.css").default;

module.exports =`
    <style>${style}</style>
    <div style="display: flex; align-items: center;"><label></label></div>
    <div class="combo js-select">
      <div aria-controls="listbox"
           aria-expanded="false"
           aria-haspopup="listbox"
           aria-labelledby="custom drop down widget"
           role="combobox"
           tabindex="0"></div>
      <div role="listbox"
           aria-labelledby="dropdown list"
           tabindex="-1">
      </div>
    </div>
   <label class="message"></label>
    
`;
